/* eslint-disable */
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
// utils
import { loadIfStateAvailableInSessionStorage, savePageStateInSessionStorage } from '../../../../../utils';
import { Translations, convertStringToArray } from '../../../../../utils';
// restClient
import { eapiClient, aemHostClient, taxonomyHostClient } from '../../../../../restClient';
// children
import MultiLineSelect from '../../../../common/MultiLineSelect';
import Radiobutton from '../../../../common/Radio/radioButton';
import SimpleDropdown from '../../../../common/SimpleDropdown';
import PersistLink from '../../../../common/PersistLink';
//action Creator
import {
  setInterestEnhancementAccounts,
  setInterestEnhancementCountryList,
  setInterestEnhancementDetail,
} from './../../../../CaseBody/ProductRequests/CaptureProductGlsInterestEnhancement/actions/actionCreator';
import { setSowSelectedProduct } from "../../../../createASow/actions/actionCreator"
import { blockUi, unBlockUi } from '../../../../../actions/actionCreator';

//style
import './style.css'
import { _tierSett, _interestEnhancement } from "./../Dummy/accounts"

class AddCountyAndAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noOfAccount: 0,
      selectedCountry: '',
      selectedAccounts: [],
      accounts: [],
      accCopy: [],
      showAddAccountBtn: false,
      countries: [],
      acccountAndCountry: [{
        accountId: '',
        premiumMargin: false
      }],
      errors: [],
      filterPreviousList: [],
      disableCountryList: false,
      lang: '',
      dropDownInvalid: false,
      disabledAccounts: [],
      marginApplicable: typeof this.props.data !== 'undefined' ? this.props.data.marginApplicable : ''
    }

    // var { caseId, productId } = this.props.match.params;
    this.mode = typeof this.props.location.state !== 'undefined' ? this.props.location.state.mode !== null ? 'edit' : 'add' : 'add';
    this.payload = new countryPayload(this.mode);

    // const { caseId, productId } = (this.props.match && this.props.match.params) || {}
    // const apiURLPut = `/sows/${caseId}/glses`;
    // this.apiURLPut = "/product/gls/" + productId;
    // this.apiURL = `/product/gls/${productId}/case/${caseId}/account`;
    this.apiCountryList = `/product/taxonomies/interestEnhancementCountries`;
    this.disableMultiAccount = [];
  }

  loadPageState = () => {
    // this.props.setInterestEnhancementAccounts(this.props.accounts);
    this.getTaxanomyUrl();
    // eapiClient(this.apiURL)
    //   .then(({ data }) => {
    //     this.props.setInterestEnhancementAccounts(data.responseData);
    //     this.getTaxanomyUrl();
    let countryName = this.countryName(this.state.selectedCountry)
    if (countryName !== undefined && countryName !== '') {
      let set = this.props.accounts.filter(id => this.countryName(id.location.value).toLowerCase().replace(/\s/g, '') === countryName.toLowerCase())

      this.setState({
        accounts: set,
        accCopy: this.props.accounts
      })
    }

    if (this.mode === 'edit') {
      let id = this.props.location.state.id;
      let lid = this.props.location.state.lid;
      const acc = this.props.data.interestEnhancement.countryAndAccount.filter(item => item.id === id)[0];
      let disAcc = acc.accounts.map(item => item.accountId);
      this.disableMultiAccount = disAcc
      this.setState({
        selectedAccounts: acc.accounts,
        selectedCountry: acc.country.value,
        currentCountryId: acc.id,
        disabledAccounts: this.disableMultiAccount,
        disableCountryList: true,
        noOfAccount: acc.accounts.length
      });
      this.payload.setPayload(this.state);
      this.payload.setIdAndLogicalIdChild(id, lid);
    } else if (this.mode === 'add') {

      this.setState({
        selectedAccounts: []
      })
    }
  }

  fetchAccountsData = () => {
    // eapiClient(this.apiURL)
    //   .then(({ data }) => {
    //     let acccountDetail = [...data.responseData]
    //     this.props.setInterestEnhancementAccounts(acccountDetail);
    //     let countryName = this.countryName(this.state.selectedCountry)
    //     if (countryName !== undefined) {
    //       let setAccounts = acccountDetail.filter(id => this.countryName(id.country.value).toLowerCase().replace(/\s/g, '') === countryName.toLowerCase())

    //       this.setState({
    //         accounts: setAccounts
    //       }, () => {
    //         this.getTaxanomyUrl();
    //       });
    //     }
    //   });
    let countryName = this.countryName(this.state.selectedCountry)
    if (countryName !== undefined && countryName !== '') {
      let set = this.props.accounts.filter(id => this.countryName(id.location.value).toLowerCase().replace(/\s/g, '') === countryName.toLowerCase())

      this.setState({
        accounts: set,
        // accCopy: this.props.accounts
      }, () => {
        this.getTaxanomyUrl();
      });
    }
  }

  countryName = (name) => {
    let countryArray = name.split(':')
    let valLen = countryArray.length;
    let countryName = countryArray[valLen - 2]

    return countryName;
  }

  componentDidMount() {
    this.setState({
      lang: this.props.lang.currentLang.lang
    })

    var showAddAccountBtn = false
    if (this.state.selectedCountry.length <= 0 && typeof this.props.accounts !== 'undefined') {
      let acccountDetail = this.props.accounts
      let countryName = this.countryName(this.state.selectedCountry)
      if (countryName !== undefined && countryName !== '') {
        let setAccounts = acccountDetail.filter(id => this.countryName(id.location.value).toLowerCase().replace(/\s/g, '') === countryName.toLowerCase())
        showAddAccountBtn = true
        this.setState({
          accounts: setAccounts
        });
      }
    } else if (this.state.selectedCountry.length > 0 && typeof this.props.accounts !== 'undefined') {
      showAddAccountBtn = true
      let detail = this.props.accounts
      let _name = this.countryName(this.state.selectedCountry)
      let set = detail.filter(id => this.countryName(id.location.value).toLowerCase().replace(/\s/g, '') === _name.toLowerCase())
      let prevCountry = this.props.data.interestEnhancement.countryAndAccount.filter(item => item.country.name.toLowerCase() === _name.toLowerCase())
      this.setState({
        accounts: set,
        showAddAccountBtn: showAddAccountBtn,
        filterPreviousList: prevCountry[0] !== undefined ? prevCountry[0].accounts : []
      });
    }

    var getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    var getCurrentDropDownValue = window.sessionStorage.getItem('key' + getCurrentDropDown);
    if (getCurrentDropDown !== null) {
      var getCurrentDropDownName = getCurrentDropDown.substring(0, getCurrentDropDown.length - 1);
    }
    if (getCurrentDropDownName === 'standAloneAccounts') {
      var getCurrentDropDownIndex = getCurrentDropDown.substring(getCurrentDropDown.length - 1);
    }

    let accountDetail = [...this.state.selectedAccounts]
    if (getCurrentDropDownName === 'standAloneAccounts' && getCurrentDropDownValue !== undefined) {
      // let currency = nextProps.otherAccounts.map((item,key) => {
      //   if(item.id === getCurrentDropDownValue){
      //    return item.currency
      //   }
      // })
      var dropdownValue = JSON.parse(getCurrentDropDownValue)
      if (dropdownValue !== null) {

        accountDetail[getCurrentDropDownIndex] = {
          accountId: dropdownValue.id,
          currency: dropdownValue.currency.name,
          premiumMargin: accountDetail[getCurrentDropDownIndex].premiumMargin
        };
      }
      let disableItem = accountDetail.map(item => item.accountId)
      this.disableMultiAccount = disableItem

      let localObject = { target: { name: 'multiAccount', value: accountDetail } }
      this.setState({
        selectedAccounts: accountDetail,
        disabledAccounts: disableItem,
        showAddAccountBtn: showAddAccountBtn
      })

      let localPayloadObj = {
        name: 'accounts',
        value: this.state.selectedAccounts
      }
      this.payload.setPayload(localPayloadObj);
    }
    window.sessionStorage.removeItem("getCurrentDropDown");
    window.sessionStorage.removeItem('key' + getCurrentDropDown);
  }

  componentWillMount() {

    loadIfStateAvailableInSessionStorage(this, () => {
      this.fetchAccountsData();
    }, () => {
      this.loadPageState()
    });
    aemHostClient("/aemData/formData/json_sow-add-account-form")
      .then(({ data }) => {
        this.setState({
          addAccountFormJson: data.guideContainer.rootPanel.items
        });
        this.getTaxanomyUrl();
      });
  }

  getCountryTaxanomy = () => {
    taxonomyHostClient(this.apiCountryList)
      .then(({ data }) => {
        let setCountries = data !== undefined && data.responseData !== undefined ? data.responseData.classificationNodes : '';
        if (this.mode === 'edit') {
          this.props.setInterestEnhancementCountryList(data.responseData);
        }
        else {
          this.props.data.interestEnhancement.countryAndAccount.filter(countyId => {
            setCountries = setCountries.filter(countriesId => countriesId.id !== countyId.country.value)
          })
          this.props.setInterestEnhancementCountryList(setCountries);
        }
      });
  }

  getAccountCountryTaxanomy = () => {
    let accounts = this.props.accounts;
    let accTaxanomy = this.state.addAccountFormJson !== undefined && this.state.addAccountFormJson.guidedropdownlist_selectCountry !== undefined ? this.state.addAccountFormJson.guidedropdownlist_selectCountry.accountTaxonomy : '';
    taxonomyHostClient(this.translations(accTaxanomy))
      .then(({ data }) => {
        if (data.responseData !== undefined) {
          let currentListCountries = data.responseData.countryTaxonomy.classificationNodes;
          if (accounts !== undefined) {
            accounts = accounts.map(item => {
              currentListCountries.filter(countItem => {
                if ('country' in item) {
                  if (countItem.id === item.location.value) {
                    item.location.name = countItem.name
                    if (item.accountType !== undefined) {
                      countItem.associations.filter(accountType => {
                        if (accountType.id === item.accountType.value) {
                          item.accountType.name = accountType.name
                        }
                      })
                    }
                  }
                }
                return item;
              });
              this.setState([...accounts]);
              this.props.setInterestEnhancementAccounts(accounts);
            });
          }
        }
      });
  }

  getTaxanomyUrl = () => {
    // this.apiCountryList = this.state.addAccountFormJson !== undefined && this.state.addAccountFormJson.guidedropdownlist_selectCountry !== undefined ? this.translations(this.state.addAccountFormJson.guidedropdownlist_selectCountry.glsIETaxonomy) : '';
    this.getCountryTaxanomy();
    this.getAccountCountryTaxanomy();
  }

  saveState = () => {
    savePageStateInSessionStorage(this.state, this.props.history.location.pathname);
  }

  componentWillReceiveProps(nextProps) {
    //_state['selectedCountry'] = typeof nextProps.selectedCountry !== 'undefined' ? nextProps.selectedCountry.value : '';
    let setAccounts;
    var showAddAccountBtn = false
    const acc = nextProps.data.interestEnhancement.countryAndAccount && nextProps.data.interestEnhancement.countryAndAccount[0];
    let countryName = acc !== undefined ? this.countryName(acc.country.value) : '';
    let acccountDetail = nextProps.accounts;
    let prevCountry = []
    if (countryName !== undefined && countryName !== '') {
      showAddAccountBtn = true;
      prevCountry = nextProps.data.interestEnhancement.countryAndAccount.filter(item => item.country.name.toLowerCase() === countryName.toLowerCase())
    }

    if (acccountDetail !== undefined) {
      setAccounts = acccountDetail.filter(id => this.countryName(id.location.value).toLowerCase().replace(/\s/g, '') === countryName.toLowerCase())
    }
    this.setState({
      filterPreviousList: prevCountry !== undefined && prevCountry[0] !== undefined ? prevCountry[0].accounts : [],
      accCopy: typeof nextProps.accounts !== 'undefined' ? nextProps.accounts : [],
      marginApplicable: typeof nextProps.data !== 'undefined' ? nextProps.data.marginApplicable : true,
      countries: typeof nextProps.countries !== 'undefined' ? typeof nextProps.countries.classificationNodes !== 'undefined' ? nextProps.countries.classificationNodes : nextProps.countries : [] || []
    });

    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      this.getTaxanomyUrl();
    }

    this.payload.setPayload(this.state);
    this.payload.setReturnPayload(this.state);
    this.payload.setIdAndLogicalIdParent(this.props.data);
  }


  //code

  setCountry = (event) => {
    let acccountDetail = [...this.state.accCopy]
    let setCountryName;
    let val = event.target.value;
    let countryArray = val.split(':')
    let valLen = countryArray.length;
    let countryName = countryArray[valLen - 2];

    if (this.props.countries.classificationNodes !== undefined) {
      this.props.countries.classificationNodes.filter(countyId => {
        if (countyId.id === val) {
          setCountryName = countyId.name
        }
      })
    } else {
      this.props.countries.filter(countyId => {
        if (countyId.id === val) {
          setCountryName = countyId.name
        }
      })
    }
    let setAccounts = acccountDetail.filter(id => this.countryName(id.location.value).toLowerCase().replace(/\s/g, '') === countryName.toLowerCase())

    let _currentArr = [];

    this.state.marginApplicable === true
      ? _currentArr = [{ accountId: '', premiumMargin: false, currency: '' }]
      : _currentArr = [{ accountId: '', premiumMargin: false, currency: '' }]

    this.setState({
      selectedCountry: event.target.value,
      accounts: setAccounts,
      dropDownInvalid: false,
      selectedAccounts: _currentArr,
      noOfAccount: 1,
      disabledAccounts: []
    });

    let localPayloadObj = {
      name: "country",
      value: {
        name: setCountryName,
        value: event.target.value
      }
    }
    this.disableMultiAccount = [];
    this.payload.setPayload(localPayloadObj);
  }

  addAccounts = () => {
    let _currentArr = [...this.state.selectedAccounts];

    this.state.marginApplicable === true
      ? _currentArr.push({ accountId: '', premiumMargin: false, currency: '' })
      : _currentArr.push({ accountId: '', premiumMargin: false, currency: '' })

    this.setState(prevState => ({
      noOfAccount: prevState.noOfAccount + 1,
      selectedAccounts: _currentArr,
      showAddAccountBtn: false
    }));

    if (this.state.selectedCountry === '') {
      this.setState({
        accounts: []
      })
    }
  }

  goToBackPage = () => {
    this.props.history.goBack();
  }

  handleAccountChange = (index, account) => {
    let _state = this.state;
    let e = index;
    if (typeof index.target !== 'undefined') {
      let eventName = e.target.name;
      let eventNamesArr = eventName.split("_");
      let indexNo = eventNamesArr[1];
      let value = index.target.value === 'yes' ? true : false;
      _state.selectedAccounts[indexNo].premiumMargin = value;
    } else {
      let accountDetail = [...this.state.selectedAccounts]
      accountDetail[index] = account.id;

      this.disableMultiAccount.indexOf(account.id) === -1 && this.disableMultiAccount.includes(account.id)
        ? this.disableMultiAccount.push(account.id)
        : this.disableMultiAccount

      this.disableMultiAccount[index] = account.id

      this.setState({
        selectedAccounts: accountDetail,
      });
      _state.disabledAccounts = this.disableMultiAccount
      _state.showAddAccountBtn = true
      _state.selectedAccounts[index].currency = account.currency.name;
      _state.selectedAccounts[index].accountId = accountDetail[index];
    }


    this.setState(_state);
    let localPayloadObj = {
      name: 'accounts',
      value: this.state.selectedAccounts
    }
    this.payload.setPayload(localPayloadObj);
  }

  accountDeletion = (index, data) => {
    let accountDetails = [...this.state.selectedAccounts];
    let countryName = this.countryName(this.state.selectedCountry)
    let prevCountry = this.props.data.interestEnhancement.countryAndAccount.filter(item => item.country.name.toLowerCase() === countryName.toLowerCase())
    let remain = prevCountry[0] !== undefined ? prevCountry[0].accounts.filter(item => item.accountId !== data.accountId) : [];

    let filterDisabledList = this.state.disabledAccounts.filter(id => id !== data.accountId)
    this.disableMultiAccount = filterDisabledList
    let filterVal;

    if (prevCountry[0] !== undefined) {
      filterVal = this.state.filterPreviousList.filter(item => item.accountId !== data.accountId)
    }
    accountDetails.splice(index, 1)

    this.setState(prevState => ({
      noOfAccount: prevState.noOfAccount - 1,
      selectedAccounts: accountDetails,
      filterPreviousList: remain,
      disabledAccounts: filterDisabledList,
      filterPreviousList: filterVal,
      showAddAccountBtn: true
    }));

    let remainAccounts = accountDetails.filter(id => id.accountId !== '')
    let localPayloadObj = {
      name: 'accounts',
      value: remainAccounts
    }
    this.payload.setPayload(localPayloadObj);
  }

  filterVal = (current, prev) => {
    let filerAccount = [];
    if (current !== undefined) {
      for (var i = 0; i < current.length; i++) {
        let flag = 0;

        for (var j = 0; j < prev.length; j++) {
          if (current[i].accountId === prev[j].accountId) {
            flag = 1
          }
        }
        if (flag === 0) {
          filerAccount.push(current[i])
        }
      }
      return filerAccount
    }
  }

  validatePayloadData = (data) => {
    let finalPayload;
    let countryName = this.countryName(this.state.selectedCountry)
    let prevCountry = this.props.data.interestEnhancement.countryAndAccount.filter(item => item.country.name.toLowerCase() === countryName.toLowerCase() && item.status !== 'urn:hsbc:cmb:gdocs:products:taxonomies:status:delete')

    this.setState({
      filterPreviousList: prevCountry[0] !== undefined && prevCountry[0].status !== 'urn:hsbc:cmb:gdocs:products:taxonomies:status:delete' ? prevCountry[0].accounts : []
    })

    if (prevCountry.length > 0) {

      let prevCountryAccount = this.state.filterPreviousList.length > 0 ? this.state.filterPreviousList : prevCountry[0].accounts;
      let currentCountryAccount = data.interestEnhancement.countryAndAccount[0].accounts
      //let displayCountry = this.filterVal(currentCountryAccount, prevCountryAccount)
      let validDisplayData = currentCountryAccount !== undefined ? currentCountryAccount.filter(id => id.accountId !== '') : prevCountryAccount

      finalPayload = {
        ...data,
        ...this.props.data,
        interestEnhancement: {
          countryAndAccount: [{
            accounts: validDisplayData,
            country: data.interestEnhancement.countryAndAccount[0].country
          }],
          // eChannelReported: this.props.data.interestEnhancement.eChannelReported,
          // reportedEChannelId: this.props.data.interestEnhancement.reportedEChannelId
        }
      }
    } else {
      let validPayloadData = data.interestEnhancement.countryAndAccount[0].accounts !== undefined ? data.interestEnhancement.countryAndAccount[0].accounts.filter(id => id.accountId !== '') : []

      finalPayload = {
        ...data,
        ...this.props.data,
        interestEnhancement: {
          countryAndAccount: [{
            accounts: validPayloadData,
            country: data.interestEnhancement.countryAndAccount[0].country
          }],
          // eChannelReported: this.props.data.interestEnhancement.eChannelReported,
          // reportedEChannelId: this.props.data.interestEnhancement.reportedEChannelId
        }
      }
    }

    return finalPayload;
  }

  submitForm = () => {
    this.props.blockUi()
    let requestedPayload = this.payload.getPayload();
    let finalPayload = this.validatePayloadData(requestedPayload);
    const { caseId } = (this.props.match && this.props.match.params) || {}

    const apiURLPut = `/sows/${this.props.data.id}/glses`;

    if (Object.keys(requestedPayload.interestEnhancement).length > 0) {
      eapiClient(apiURLPut, {
        method: 'PUT',
        data: JSON.stringify(finalPayload)
      })
        .then(({ data }) => {
          this.props.setInterestEnhancementDetail(data.responseData);
          this.props.setSowSelectedProduct(data.responseData);
          this.props.history.goBack();
          this.props.unBlockUi();
        });
    }
  }

  handleAccountEdit = (detail) => {
    var { productId } = this.props.match.params;
    if (detail) {
      savePageStateInSessionStorage(this.state, this.props.history.location.pathname);
      this.props.history.push("/sow-body/create-new-other-account-ie/" + productId + "/" + detail.accountId);
    }
  }

  setAuthorised = () => {

  }

  _renderCountryForm = () => {
    let accountJSX = [];

    if (this.state.selectedAccounts.length > 0 || this.mode === 'edit') {
      for (var i = 0; i <= this.state.noOfAccount - 1; i++) {
        accountJSX.push(
          <div className="business-contact-wrapper" key={i}>
            <div className="business-contact-position">
              <label>{this.translations(this.state.addAccountFormJson.static_text_mainTitle.accountText)} {i + 1}</label>
            </div>
            <div className="business-contact-position">
              {
                (i > 0 && !this.props.customer.roleDetails.customer)
                  ? <span
                    className="delete-btn"
                    role="button"
                    onClick={this.accountDeletion.bind(this, i, this.state.selectedAccounts[i])}
                  >
                    <i className="icon icon-bin"></i>
                  </span>
                  : ''
              }
              <MultiLineSelect
                key={'1'}
                defaultValue={this.translations(this.state.addAccountFormJson.guidedropdownlist_selectCountry._value)}
                requiredFields={{
                  "row1": ["accountType", "accountNumber", "branchCode", "currency", "country"],
                  "row2": ["accountHolder", "entityNameOther"],
                  "row3": ["bankName", "hsbcBankName", "accountTitle", "tempRefrenceId"]
                }}
                requiredFieldsPrefixes={{
                  "row1": ["", "", "", ""],
                  "row2": [""],
                  "row3": ["", ""]
                }}

                multiAccount={true}
                data={typeof this.state.accounts !== 'undefined' && this.state.selectedCountry !== '' ? this.state.accounts : []}
                value={this.state.selectedAccounts[i] !== undefined ? this.state.selectedAccounts[i].accountId : ''}
                disabledOptions={this.state.disabledAccounts}
                isDisable={this.props.customer.roleDetails.customer}
                _onChange={this.handleAccountChange.bind(this, i)}
                onEdit={this.handleAccountEdit.bind(this, this.state.selectedAccounts[i])}
              />
              {/* <PersistLink
                history={this.props.history}
                state={this.state}
                onClick={this.saveState}
                className={`mrg-left ${this.props.customer.roleDetails.customer ? 'disabled' : ''}`}
                to={`/sow-body/create-new-other-account-ie/${this.props.match.params.productId}`}
                data={`standAloneAccounts${i}`}
              >
                {this.translations(this.state.addAccountFormJson.guideMultiDropdownlist_accountDropdown.createText)}
              </PersistLink> */}
            </div>
            {/* {
              this.state.marginApplicable === true
                ? (<div className="section-row gdocs-mtop-20">
                  <label>{this.translations(this.state.addAccountFormJson.guideradiobutton_eligibleForPremium.title)}</label>
                  <div className="radio-row-section">
                    <label className="radio-group">
                      <Radiobutton
                        setInputvalue={this.setAuthorised}
                        name={`premiumMargin_${i}`}
                        value="yes"
                        _onChange={this.handleAccountChange}
                        _value={this.state.selectedAccounts[i] !== undefined ? (this.state.selectedAccounts[i].premiumMargin === true ? 'yes' : false) : false}
                      />
                      {this.translateWord(this.state.addAccountFormJson.static_text_mainTitle.options)[0]}
                    </label>
                    <label className="radio-group">
                      <Radiobutton
                        setInputvalue={this.setAuthorised}
                        name={`premiumMargin_${i}`}
                        value="no"
                        _onChange={this.handleAccountChange}
                        _value={this.state.selectedAccounts[i] !== undefined ? (this.state.selectedAccounts[i].premiumMargin === false ? 'no' : false) : false}
                      />
                      {this.translateWord(this.state.addAccountFormJson.static_text_mainTitle.options)[1]}
                    </label>
                  </div>
                </div>)
                : ""
            } */}
          </div>);
      }
    }
    return accountJSX;
  }

  handleBlurEvt = (event) => {
    if (event.target.value === '' || event.target.value === 'Please select') {
      this.setState({ dropDownInvalid: true });
    }
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  render() {
    return (
      (this.state.addAccountFormJson !== undefined
        ? <div className="add-county-and-account-container">
          <div className="pannel-heading-container">
            <h2 className="pannel-heading">{this.translations(this.state.addAccountFormJson.static_text_mainTitle.pageHeading)}</h2>
            <p className="optional-text">{this.translations(this.state.addAccountFormJson.static_text_mainTitle.descriptionText)}</p>
          </div>
          <div className="pannel-select-container">
            <label className="gdocs-mtop-10 gdocs-valign-top gdocs-mright-20"> {this.translations(this.state.addAccountFormJson.guidedropdownlist_selectCountry.title)} </label>
            <div className="display-inline">
              <SimpleDropdown
                options={this.state.countries}
                value={this.state.selectedCountry}
                _onChange={this.setCountry}
                defaultValue={this.translations(this.state.addAccountFormJson.guidedropdownlist_selectCountry._value)}
                optionTextSelector="name"
                disabled={this.state.disableCountryList}
                _onBlur={this.handleBlurEvt}
              />
              {
                this.state.dropDownInvalid ? (
                  <div className="input-error-msg-section">
                    <span className="icon icon-circle-delete-solid"></span>
                    {this.translations(this.state.addAccountFormJson.guidedropdownlist_selectCountry._value)}
                  </div>
                ) : ''
              }
            </div>
          </div>
          <div className="pannel-account-section gdocs-mtop-15">
            {
              this._renderCountryForm()
            }
            <div className="gdocs-clear-float"></div>
            {this.state.showAddAccountBtn === true ? <button
              className="gdocs-btn-default"
              onClick={this.addAccounts}
              disabled={this.props.customer.roleDetails.customer}
            >
              {this.translations(this.state.addAccountFormJson.guidebutton_addAccount.text)} {this.state.noOfAccount + 1}
            </button> : ''}
          </div>
          <div className="pannel-submit-section">
            <div className="form-buttons-wrapper">
              <label
                aria-label="Add account"
                className="gdocs-mright-20 gdocs-cursor-pointer"
                onClick={this.goToBackPage}
              >
                {this.translations(this.state.addAccountFormJson.guidebutton_cancel.text)}
              </label>
              <button
                disabled={(this.state.selectedCountry.length > 0 && !this.props.customer.roleDetails.customer) ? false : true}
                aria-label="Add account"
                className="gdocs-btn-submit"
                onClick={this.submitForm}
              >
                {this.translations(this.state.addAccountFormJson.guidebutton_submit.text)}
              </button>
            </div>
          </div>
        </div>
        : ''));
  }
}
class countryPayload {
  constructor(mode) {
    this.mode = mode;
    this.data = {};
    this.countryAndAccount = {};
  }
  setIdAndLogicalIdParent(props) {
    this.data.id = props.id;
    this.data.lid = props.lid;
  }
  setIdAndLogicalIdChild(id = null, lid = null) {
    if (this.mode === 'edit') {
      this.countryAndAccount.id = id;
      this.countryAndAccount.lid = id
    }
  }
  setReturnPayload(data) {
    let setCountryName;
    let countryArray = data.selectedCountry.split(':')
    let valLen = countryArray.length;
    let countryName = countryArray[valLen - 2]
    data.countries.filter(countyId => {
      if (countyId.id === data.selectedCountry) {
        setCountryName = countyId.name
      }
    })
    if (data.selectedCountry !== '' && typeof data.selectedCountry !== 'object') {
      this.countryAndAccount.country = {
        name: setCountryName,
        value: data.selectedCountry
      }
      this.countryAndAccount.accounts = data.selectedAccounts;
    } else if (typeof data.selectedCountry === 'object') {
      this.countryAndAccount.country = {
        name: setCountryName,
        value: data.selectedCountry
      }
      this.countryAndAccount.accounts = data.selectedAccounts;

    }
  }
  setPayload(data) {
    switch (data.name) {
      case "country":
        this.countryAndAccount.country = data.value;
        break;
      case "accounts":
        this.countryAndAccount.accounts = data.value;
        break;
      default:
    }
  }
  getPayload() {

    var payload = {
      interestEnhancement: {
        countryAndAccount: [this.countryAndAccount]
      },
      ...this.data
    }
    return payload;
  }
}

const mapStateToProps = state => {
  let poolAccounts = []
  const { location = {}, notionalPooling = {} } = (state.sowEntities && state.sowEntities.selectedSowProduct) || {}
  if (state.sowEntities.allAccounts) {
    poolAccounts = state.sowEntities.allAccounts
  }
  return {
    // accounts: state.currentProductInterestEnhancement.accounts,
    countries: state.currentProductInterestEnhancement.countries,
    data: state.currentProductInterestEnhancement.data,
    // data: _interestEnhancement,
    customer: state.auth.userDetails,
    myData: state,
    accounts: poolAccounts,
    lang: state.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setInterestEnhancementAccounts: accounts => {
      dispatch(setInterestEnhancementAccounts(accounts));
    },
    setInterestEnhancementCountryList: countries => {
      dispatch(setInterestEnhancementCountryList(countries));
    },
    setInterestEnhancementDetail: Detail => {
      dispatch(setInterestEnhancementDetail(Detail));
    },
    setSowSelectedProduct: data => {
      dispatch(setSowSelectedProduct(data));
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(AddCountyAndAccount);


// WEBPACK FOOTER //
// ./src/components/SowBody/GLSProduct/InterestEnhancementSummary/SowAddCountyAndAccount/index.js